export interface BreadcrumbItem {
  name: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': item.href ? `https://anhuicloud.cn${item.href}` : 'https://anhuicloud.cn',
        name: item.name,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-500 overflow-x-auto whitespace-nowrap">
        {items.map((item, index) => (
          <span key={index} className="flex items-center">
            {index > 0 && (
              <i className="ri-arrow-right-s-line mx-2 text-foreground-400"></i>
            )}
            {item.href ? (
              <a href={item.href} className="hover:text-primary-500 transition-colors cursor-pointer">
                {item.name}
              </a>
            ) : (
              <span className="text-foreground-700 font-medium">{item.name}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}